export { default, ResourcesSelect } from './ResourcesSelect';